export const CompetitionsEvent = {
  CompetitionLandingView: 'competition_landing_view',
  CompetitionRegisterClick: 'competition_register_click',
  CompetitionRankingPageView: 'competition_ranking_page_view',
  CompetitionRankingPageCancelRegistrationClick: 'competition_ranking_page_cancel_registration_click',
  CompetitionRankingPageTradeNowClick: 'competition_ranking_page_trade_now_click',
  CompetitionRankingPageInfoClick: 'competition_ranking_page_info_click',
  CompetitionLandingViewClickCta: 'competition_landing_view::click_cta',
  CompetitionLandingViewPageScroll: 'competition_landing_view::page_scroll',
  // private competition
  CompetitionEnterCodeModalView: 'competition_enter_code_modal_view',
  CompetitionEnterCodeModalEnterCodeClick: 'competition_enter_code_modal_enter_code_click',
  CompetitionEnterCodeModalJoinClick: 'competition_enter_code_modal_join_click',
  // TC Revamp (2025.12.01)
  CompetitionTradingMainPageView: 'competition_trading_main_page_view',
  CompetitionTradingRegisterClick: 'competition_trading_register_click',
  CompetitionTradingShareClick: 'competition_trading_share_click',
  CompetitionTradingSharePanelView: 'competition_trading_share_panel_view',
  CompetitionTradingSharePanelClick: 'competition_trading_share_panel_click',
  CompetitionTradingRuleLearnMoreClick: 'competition_trading_rule_learn_more_click',
  CompetitionTradingLastLeaderboardListClick: 'competition_trading_last_leaderboard_list_click',
  CompetitionTradingFaqListClick: 'competition_trading_faq_list_click',
  CompetitionTradingEventTabClick: 'competition_trading_event_tab_click',
  CompetitionTradingTradeClick: 'competition_trading_trade_click',
  CompetitionTradingMyRankClick: 'competition_trading_my_rank_click',
  CompetitionTradingLeaderboardListClick: 'competition_trading_leaderboard_list_click',
} as const;

export interface CompetitionsEventDataType {
  [CompetitionsEvent.CompetitionLandingView]: {
    competition_id: string;
  };
  [CompetitionsEvent.CompetitionRegisterClick]: {
    competition_id: string;
  };
  [CompetitionsEvent.CompetitionRankingPageView]: {
    competition_id: string;
    competition_type: 'volume' | 'pnl';
    prize_type: 'milestone' | 'fixed';
    current_prize: number;
    max_prize: number;
    user_rank: number;
    user_tc_amount: number;
  };
  [CompetitionsEvent.CompetitionLandingViewClickCta]: {};
  [CompetitionsEvent.CompetitionRankingPageCancelRegistrationClick]: {
    competition_id: string;
  };
  [CompetitionsEvent.CompetitionRankingPageTradeNowClick]: {
    competition_id: string;
  };
  [CompetitionsEvent.CompetitionRankingPageInfoClick]: {
    competition_id: string;
  };
  [CompetitionsEvent.CompetitionLandingViewPageScroll]: {
    section_title: string;
  };
  // private competition
  [CompetitionsEvent.CompetitionEnterCodeModalView]: {
    competition_id: string;
  };
  [CompetitionsEvent.CompetitionEnterCodeModalEnterCodeClick]: {
    competition_id: string;
  };
  [CompetitionsEvent.CompetitionEnterCodeModalJoinClick]: {
    competition_id: string;
  };
  // TC Revamp (2025.12.01)
  [CompetitionsEvent.CompetitionTradingMainPageView]: {
    competition_id: string;
  };
  [CompetitionsEvent.CompetitionTradingRegisterClick]: {
    competition_id: string;
    button_location: string;
  };
  [CompetitionsEvent.CompetitionTradingShareClick]: {
    competition_id: string;
  };
  [CompetitionsEvent.CompetitionTradingSharePanelView]: {
    competition_id: string;
    is_logged_in: boolean;
    referral_code?: string;
  };
  [CompetitionsEvent.CompetitionTradingSharePanelClick]: {
    competition_id: string;
    is_logged_in: boolean;
    referral_code?: string;
    share_type: 'copy_link' | 'telegram' | 'x' | 'facebook' | 'download';
  };
  [CompetitionsEvent.CompetitionTradingRuleLearnMoreClick]: {
    competition_id: string;
  };
  [CompetitionsEvent.CompetitionTradingLastLeaderboardListClick]: {
    competition_id: string;
    nickname: string;
    list_order: number;
  };
  [CompetitionsEvent.CompetitionTradingFaqListClick]: {
    competition_id: string;
    list_order: number;
  };
  [CompetitionsEvent.CompetitionTradingEventTabClick]: {
    competition_id: string;
    list_order: number;
    competition_status: string;
  };
  [CompetitionsEvent.CompetitionTradingTradeClick]: {
    competition_id: string;
    button_location: string;
  };
  [CompetitionsEvent.CompetitionTradingMyRankClick]: {
    competition_id: string;
  };
  [CompetitionsEvent.CompetitionTradingLeaderboardListClick]: {
    competition_id: string;
    list_order: number;
    nickname: string;
  };
}
